import {
    Alert,
    FlatList,
    LayoutAnimation,
    Platform, Pressable,
    StyleSheet,
    Text, TouchableOpacity,
    View,
} from 'react-native';
import React, {useState, useRef, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {theme} from '../../../config';
import {loggedInClient} from '../../../services/rest';
import JSZip from "jszip";
import translate from '../../../services/localization';
import { Icon } from '@rneui/themed';
import { setPickedFiles } from '../../../store/globals.slice';
import { setAnswer } from '../../../store/questionnaire.slice';


export default function FilePicker({ item }) {
    const dispatch = useDispatch();
    const [localPickedFiles, setLocalPickedFiles] = useState([]); // displays picked files
    const [expanded, setExpanded] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const dropRef = useRef(null);

    const subjectId = useSelector((state) => state.User.subjectId);
    const { categoryIndex, categories, fetchQuestionnaire } = useSelector(
      (state) => state.Questionnaire,
    );
    const { pickedFiles } = useSelector(state => state.Globals);

    // const [zippedFile, setZippedFile] = useState(File);

    // Drag and drop
    useEffect(() => {
        if (Platform.OS !== 'web') return;

        const dropArea = dropRef.current;
        if (!dropArea) return;

        const handleDragOver = (e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsDragging(true);
        };

        const handleDragLeave = (e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsDragging(false);
        };

        const handleDrop = (e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsDragging(false);

            const files = Array.from(e.dataTransfer.files);
            if (files.length) {
                console.log('Dropped files:', files.map(f => f.name));
                storePickedFile(files);
                setLocalPickedFiles(files);
            }
        };

        dropArea.addEventListener('dragover', handleDragOver);
        dropArea.addEventListener('dragleave', handleDragLeave);
        dropArea.addEventListener('drop', handleDrop);

        return () => {
            dropArea.removeEventListener('dragover', handleDragOver);
            dropArea.removeEventListener('dragleave', handleDragLeave);
            dropArea.removeEventListener('drop', handleDrop);
        };
    }, []);

    useEffect(() => {
        // Check stored picked files
        handleLoad();
    },[])

    const pickFile = async () => {
        try {
            if (Platform.OS === 'web') {
                // --- Web fallback using HTML input ---
                const input = document.createElement('input');
                input.type = 'file';
                input.multiple = false;
                input.onchange = (event) => {
                    const selectedFileObjects = Array.from(event.target.files);
                    storePickedFile(selectedFileObjects);
                    setLocalPickedFiles(selectedFileObjects);
                };
                input.click();
            }
        } catch (err) {
            console.log('FilePicker','Error:', err);
        }
    };

    // Store picked files in redux state
    const storePickedFile = async (files) => {
        console.log('FilePicker', 'storePickedFile', files);
        // Store picked files for resume state
        dispatch(setPickedFiles({
            linkId: item.linkId,
            pickedFiles: files
        }));

        // const arrayBufferFile = await files.arrayBuffer();
        // const base64file = await arrayBufferToBase64(arrayBufferFile);

        // TODO: Handle multiple files
        const base64Files = await Promise.all(
            files.map(async (file) => {
                const arrayBufferFile = await file.arrayBuffer();
                return await arrayBufferToBase64(arrayBufferFile);
            })
        );

        console.log('FilePicker', 'Base64 ', base64Files);
        // Store picked files for questionnaire upload
        dispatch(
            setAnswer({
                linkId: item.linkId,
                answer: {
                    [`valueBase64File`]: base64Files[0],
                },
            }),
        );
    };

  const arrayBufferToBase64 = (arrayBuffer) => {
      return new Promise((resolve, reject) => {
          const blob = new Blob([arrayBuffer]);

          const reader = new FileReader();

          reader.onloadend = () => {
            // Result is: data:application/octet-stream;base64,xxxx
            const base64 = reader.result.split(',')[1];
            resolve(base64);
          };

          reader.onerror = reject;

          reader.readAsDataURL(blob);
      });
  };

    const removePickedFile = async (fileIndex) => {
        const updatedFiles = localPickedFiles.filter(
        (_, index) => index !== fileIndex
        );

        setLocalPickedFiles(updatedFiles);
        await storePickedFile(updatedFiles);
    };

    const toggleExpand = () => {
        LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
        setExpanded((prev) => !prev);
    };

    const uploadZipFiles = async (zipBlob) => {
        let allFilesSent = true;

        if (zipBlob !== null) {
            console.log('FilePicker', 'submitting file... ');
            try {
                await loggedInClient.importRecord(
                    subjectId,
                    categories[categoryIndex].instrument_name,
                    item.origCode,
                    zipBlob,
                    item.origCode);
            } catch (e) {
                allFilesSent = false;
                throw e;
            }
        }

        if (allFilesSent) {
            storePickedFile([]);
            setLocalPickedFiles([]);
            console.log('FilePicker', 'all files sent');
            Alert.alert('Hochladen erfolgreich', 'Ihr Datei wird erfolgreich abgeschickt.', [{text: 'OK'}]);
        }
    };

    const uploadPickedFiles = async () => {
        try {
            let i = 0;
            const zip = new JSZip();
            for (const filePath of localPickedFiles) {
                console.log('FilePicker', 'Adding file to zip', filePath.name, filePath);
                // Add each selected file to the ZIP
                const content = await filePath.arrayBuffer(); // read file as arrayBuffer
                zip.file(filePath.name, content);

                i++;
            }
            const unixTimeSec = Math.floor(Date.now() / 1000);

            // Generate ZIP blob
            const zipBlob = await zip.generateAsync({ type: 'blob' });
            // const zipFile = new File([zipBlob], `data_${unixTimeSec}.zip`, { type: 'application/zip' });

            console.log('FilePicker', 'Files zipped, starting upload!');

            // setZippedFile(zipBlob);
            await uploadZipFiles(zipBlob);

        } catch (err) {
            console.error(err);

            Alert.alert('Fehler',
                'Ein Fehler ist bei der Kommunikation mit dem Server aufgetreten.\n' +
                'Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.\n\n' +
                'Tippen Sie auf diese Nachricht um sie zu schließen.', [{text: 'OK'}]);
        }
    };

    const handleLoad = () => {
        if (pickedFiles) {
            console.log('FilePicker', 'Stored picked files found! Load stored data...', item.linkId, pickedFiles?.[item.linkId]);
            storePickedFile(pickedFiles?.[item.linkId] ?? []);
            setLocalPickedFiles(pickedFiles?.[item.linkId] ?? []);
        }   else {
            console.warn('FilePicker', 'No stored picked files to load');
        }

    };

    return (
        <View>
            <View style={{paddingTop: 20}}/>
            <View style ={{
                flex: 1,
                alignItems: 'center', }}>
                <TouchableOpacity
                    style={localStyle.buttonDefaultGrey}
                    onPress ={() => {
                        pickFile().then();
                    }}>
                    <Text style={localStyle.buttonTextDefault}>
                        {translate('filePicker').chooseFile}
                    </Text>
                </TouchableOpacity>
            </View>
            {Platform.OS === 'web' && (
                <View style={localStyle.dropZoneContainer}>
                    <View
                        ref={dropRef}
                        style={[
                            localStyle.dropZone,
                            isDragging && localStyle.dropZoneActive,
                        ]}
                    >
                        <Text style={localStyle.dropZoneText}>
                            {isDragging
                                ? translate('filePicker').dropFilesHere
                                : translate('filePicker').dragAndDrop}
                        </Text>
                    </View>
                </View>
            )}
            {localPickedFiles.length > 0 && (
                <View style={{ marginTop: 40}}>
                    {/*<View style ={{*/}
                    {/*    flex: 1,*/}
                    {/*    alignItems: 'center', }}>*/}
                    {/*    <TouchableOpacity*/}
                    {/*        style={localStyle.buttonDefaultBlue}*/}
                    {/*        onPress ={() => {*/}
                    {/*            uploadPickedFiles().then();*/}
                    {/*        }}>*/}
                    {/*        <Text style={localStyle.buttonTextDefault}>*/}
                    {/*            {translate('filePicker').uploadFiles}*/}
                    {/*        </Text>*/}
                    {/*    </TouchableOpacity>*/}
                    {/*</View>*/}

                    <FlatList
                        style={{paddingTop: 50}}
                        scrollEnabled={false}
                        data={localPickedFiles}
                        keyExtractor={(fileItem, index) => `${fileItem.name}-${index}`}
                        renderItem={({ item, index }) => (
                            <View
                                style={{
                                    paddingVertical: 8,
                                    borderBottomWidth: 1,
                                    borderColor: '#ccc',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                }}>
                                <Text style={{ fontSize: 16, flex: 3}}
                                      ellipsizeMode={'head'}
                                >{`(${index + 1}) ${localPickedFiles[index].name}`}</Text>
                                <Text style={{ color: '#555', fontSize: 16, flex: 1, textAlign: 'right' }}>
                                    {formatBytes(localPickedFiles[index].size) ?? 'N/A'}
                                </Text>
                                <TouchableOpacity
                                    style={{height : 40 , width: 40, padding: 8}}
                                    onPress={() => removePickedFile(index)}>
                                    <Icon
                                        name="trash-can-outline"
                                        type="material-community"
                                        color={'#FF0000'}
                                    />
                                </TouchableOpacity>
                            </View>
                        )}
                    />
                    {/*}*/}
                </View>
            )}
        </View>
    );
}

const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    return `${value} ${sizes[i]}`;
};

const localStyle = StyleSheet.create({
    buttonDefaultGrey: {
        backgroundColor: theme.colors.primary_grey_main,
        maxWidth: 400,
        paddingVertical: 12,
        paddingHorizontal: 20,
        borderRadius: 6,
    },
    buttonDefaultBlue: {
        backgroundColor: theme.colors.primary_blue_main,
        maxWidth: 400,
        paddingVertical: 12,
        paddingHorizontal: 20,
        borderRadius: 6,
    },
    buttonTextDefault: {
        color: 'white',
        fontSize: 20,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    dropZoneContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 30,
    },

    dropZone: {
        width: '80%',
        maxWidth: 500,
        borderWidth: 2,
        borderStyle: 'dashed',
        borderColor: '#aaa',
        borderRadius: 10,
        backgroundColor: '#f5f5f5', // light gray background
        paddingVertical: 40,
        paddingHorizontal: 20,
        alignItems: 'center',
        justifyContent: 'center',
    },

    dropZoneActive: {
        borderColor: theme.colors.primary_blue_main,
        backgroundColor: '#e0f0ff', // subtle blue highlight when dragging
    },

    dropZoneText: {
        color: '#555',
        fontSize: 16,
        textAlign: 'center',
    },
});
